export default "__VITE_ASSET__BxwbWNP7__"